import { Page } from 'model/Page';
import { ItemListaNotificacoes } from 'view/extrair/Notificacao/model/ItemListaNotificacoes';
import { ApiAxios } from '../../../../../service/api/ApiAxios';

export class ApiNotificacoes {

  static async getAll(): Promise<Page<ItemListaNotificacoes>> {
    const response = await ApiAxios.instance.get(`${process.env.REACT_APP_NOTIFICACAO_HOST}/lista/itens?sort=dataNotificacao,desc`)

    return response.data;
  }

  static async marcarComo(item: ItemListaNotificacoes, visualizado: boolean): Promise<object> {
    const body = {
      visualizado: visualizado
    }
    const response = await ApiAxios.instance.patch(`${process.env.REACT_APP_NOTIFICACAO_HOST}/lista/itens/${item.id}`, body);

    return response.data;
  }
}
